import React from 'react'
import '../../App.css';
import '../login/loginPop.css'

const Modal = ({ modalType, setModalType, children, onClose }) => (
    <div className="login-pop">
        <div className="login-outer">
            <div className={`${modalType === "forgot-password" ? "login-forgot" : "login-content"}  ${modalType === "login" ? "active" : ""}`}>
                {children}
                <p>Don’t Have an Account ? <a href="#" onClick={() => setModalType("register")}>Sign Up</a></p>
                <button onClick={onClose} className="close-btn">
                    Close
                </button>
            </div>
            <div className={`register-content ${modalType === "register" ? "active" : ""}`}>
                {children}
                <p>Already Have an Account ? <a href="#" onClick={() => setModalType("login")}>Login</a></p>
                <button onClick={onClose} className="close-btn">
                    Close
                </button>
            </div>
        </div>
    </div>
);

export default Modal;